/// <reference path="../../../node_modules/@1js/office-online-strings/en-US/transcription-strings.d.ts" />
import { ITranscriptionManager, ITranscription } from '../interfaces/ITranscriptionManager'
import { LogEvents } from '../../utils/LogEvents';
import { DurationMeasureType } from '../interfaces/ILogEvent'
import { AddTranscriptionToDocumentKeys } from '../office-js/telemetry/OfficeJSKeys';
import { ITranscriptionSourceFile } from '../interfaces/ITranscriptionSourceFileProvider';
import { IAddTranscriptionToCanvas, AddToDocumentOptions, GetMergedSpeakerTranscription} from '../interfaces/IAddTranscriptionToCanvas';
import { GetSpeakerName } from '../../frontend/common/actions/TranscribingActions';
import { ErrorStringFromException } from '../../utils/utils';
import { FormatTime } from '../../frontend/utils';

type formattedTranscriptHTML = { textSegmentsList: string[], characterCount: number };
export class AddTranscriptionToONNotebook implements IAddTranscriptionToCanvas {

  async  AddTranscriptionToDocument(transcription: ITranscription, sourceFile: ITranscriptionSourceFile | null, addOption: AddToDocumentOptions) {
    LogEvents.OfficeJS.Start();
    LogEvents.OfficeJS.BeginDurationMeasure(DurationMeasureType.Normal, AddTranscriptionToDocumentKeys.AddTranscriptionToDocumentDuration);

    try {
      let characterCount = 0;
      let combinedAddToDocumentHTMLString = "";
      await OneNote.run(async (context) => {

        if (sourceFile != null) {

          // Insert audio file section
          combinedAddToDocumentHTMLString += "<p><h4>" + TranscriptionStrings.InDocumentTranscriptAudioFileHeading + "</h4></p>";
          characterCount += TranscriptionStrings.InDocumentTranscriptAudioFileHeading.length;

          characterCount += 1;

          let audioNameWithURL = "<a href="+ sourceFile.permanentAudioUrl+ ">"  + sourceFile.fileName +"</a>"
          combinedAddToDocumentHTMLString += "<p>" + audioNameWithURL + "</p>" + "<p>" + '<br>' + "</p>"; // adding <br> for extra line space before Transcript heading.
          characterCount += sourceFile.fileName.length;
        }

        // Insert transcript section
        combinedAddToDocumentHTMLString += "<p><h4>" + TranscriptionStrings.InDocumentTranscriptTranscriptHeading + "</h4></p>";

        // Doing insert call on text till Transcript heading
        context.application.insertHtmlAtCurrentPosition(combinedAddToDocumentHTMLString);
        context.sync();

        let textSegmentsList: string [] = [];
        const formattedHtml = this.FormatTranscriptionHTML(transcription, characterCount, addOption);
        characterCount = formattedHtml.characterCount;
        textSegmentsList = formattedHtml.textSegmentsList;

        // Complete transcription is available in textSegmentsList.
        context.application.insertHtmlAtCurrentPosition(textSegmentsList.join(''));
        context.sync();
      })
      LogEvents.OfficeJS.End([{ key: AddTranscriptionToDocumentKeys.CharacterCount, value: characterCount }, {key: AddTranscriptionToDocumentKeys.AddTranscriptionToDocumentOptionWithTimestamps , value: addOption.withTimestamps }, {key: AddTranscriptionToDocumentKeys.AddTranscriptionToDocumentOptionWithSpeakers , value: addOption.withSpeakers }]);
    } catch (e) {
      LogEvents.OfficeJS.End([{key: AddTranscriptionToDocumentKeys.FailureReason, value: ErrorStringFromException(e)}]);
      throw e;
    }
  }

  async  AddTranscriptionSegmentToDocument(transcriptionManager: ITranscriptionManager, segmentIndex: number) {
    LogEvents.OfficeJS.Start();
    LogEvents.OfficeJS.BeginDurationMeasure(DurationMeasureType.Normal, AddTranscriptionToDocumentKeys.AddTranscriptionSegmentToDocumentDuration);

    try {
      let characterCount = 0;

      const segment = transcriptionManager.GetTranscription().transcriptSegments[segmentIndex];
      await OneNote.run(async (context) => {
        context.application.insertHtmlAtCurrentPosition("<p>" + FormatTime(segment.start) + (segment.speakerId != null ? ' ' + GetSpeakerName(segment.speakerId, transcriptionManager.GetTranscription().speakerNames) : '') + '</p><p>' + segment.text + '</p>');
        context.sync();
        if (segment.text != undefined) {
          characterCount += segment.text.length + 1;
        }
      });
      LogEvents.OfficeJS.End([{ key: AddTranscriptionToDocumentKeys.CharacterCount, value: characterCount }]);
    } catch (e) {
      LogEvents.OfficeJS.End([{key: AddTranscriptionToDocumentKeys.FailureReason, value: ErrorStringFromException(e)}]);
      throw e;
    }
  }

   private FormatTranscriptionHTML(transcription: ITranscription, characterCount : number, addOption: AddToDocumentOptions) : formattedTranscriptHTML {
    characterCount += TranscriptionStrings.InDocumentTranscriptTranscriptHeading.length;
    characterCount += 1;

    // Collecting complete transcription in textSegmentsList to later
    // insert it into OneNote page
    // Can't use segment for loop to direct insertion as it will
    // be too many request with small string sizes and complete
    // for loop execution is not taking more than 2-3 ms.
    // Note: this is a special case for solving the OCVs feedback of same speaker merged text feedback. Kept behind feature flag.
    if (!addOption.withTimestamps) {
      return this.FormatTranscriptionHTMLWithSpeakerOnlyOrJustText(transcription, characterCount, addOption);
    }

    let textSegmentsList: string[] = [];
    let textToInsert: string = '';
    for (const segment of transcription.transcriptSegments) {
      textToInsert += "<p>";
      if (addOption.withTimestamps) {
        textToInsert +=  FormatTime(segment.start);
        if (!addOption.withSpeakers) {
          textToInsert += '</p>';
        }
      }

      if (addOption.withSpeakers) {
        textToInsert += (segment.speakerId != null ? ' ' + GetSpeakerName(segment.speakerId, transcription.speakerNames) : '')  + '</p>';
      }

      if (segment.text != undefined && segment.text != "") {
        textToInsert += '<p>' + segment.text + '</p>';
        characterCount += segment.text.length + 1;
      }
      textSegmentsList.push(textToInsert);
      textToInsert = '';
    }
    return {textSegmentsList, characterCount};
  }

  private FormatTranscriptionHTMLWithSpeakerOnlyOrJustText(transcription: ITranscription, characterCount : number, addOption: AddToDocumentOptions): formattedTranscriptHTML {
    const mergedTranscription = GetMergedSpeakerTranscription(transcription);
    let textSegmentsList: string[] = [];
    let textToInsert: string = '';
    for (let index = 0; index < mergedTranscription.transcriptSegments.length; index++) {
      if (addOption.withSpeakers) {
        textToInsert += '<p>' + GetSpeakerName(mergedTranscription.transcriptSegments[index].speakerId, mergedTranscription.speakerNames) + '</p>';
      }
      if (mergedTranscription.transcriptSegments[index].text != undefined && mergedTranscription.transcriptSegments[index].text != "") {
          textToInsert += '<p>' + mergedTranscription.transcriptSegments[index].text + '</p>';
          characterCount += mergedTranscription.transcriptSegments[index].text.length + 1;
      }
      textSegmentsList.push(textToInsert);
      textToInsert = '';
    }
    return {textSegmentsList, characterCount};
  }

}
